export default "__VITE_ASSET__DdwnEtwV__"